<template>
  <div>
    <v-row align="center">
      <v-col>
        <b>{{ notification.name }}</b>
        <p>{{ notification.description }}</p>
        <div>
          Currently
          <span v-if="notification.NotificationSetting">
            {{ notification.NotificationSetting.metadata.length }}
          </span>
          <span v-else>0</span> Email(s) set.
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        v-if="notification.NotificationSetting"
        class="v-btn-with-radius"
        color="primary"
        dark
        @click="open(notification)"
      >
        Edit
      </v-btn>
      <div v-if="!notification.NotificationSetting">
        <v-btn
          class="v-btn-with-radius"
          color="primary"
          @click="open(notification)"
        >
          {{ $t("buttons.enable") }}
        </v-btn>
      </div>
      <div v-else>
        <v-btn
          class="v-btn-with-radius"
          color="error"
          @click="disableNotification(notification)"
        >
          {{ $t("buttons.disable") }}
        </v-btn>
      </div>
    </v-row>

    <!-- Dialog -->
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card :color="$style.card.background">
        <CardToolbar title="Add Email" :isModal="true" @cancel="cancel" />
        <v-container>
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="nameAndEmail.name"
                outlined
                ref="emailName"
                :label="$t('labels.name')"
                :error-messages="nameErrors"
                :hide-details="nameErrors.length === 0"
              />
            </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                v-model="nameAndEmail.email"
                outlined
                :label="$t('labels.email')"
                :error-messages="emailErrors"
                :hide-details="emailErrors.length === 0"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                class="v-btn-with-radius pt-0 mt-0 white--text"
                :disabled="$v.nameAndEmail.$invalid"
                @click="add()"
              >
                Add
              </v-btn>
            </v-col>
          </v-row>

          <!-- Email List -->
          <v-row align="center" v-if="List.length > 0">
            <v-col>
              <v-list>
                <template v-for="(row, index) in List">
                  <v-list-item :key="index">
                    <v-list-item-action>
                      <v-btn icon @click.stop.prevent="deleted(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-html="row.name"></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="row.email"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < List.length" />
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
        <CardActions
          name="editAlert"
          @submit="submit"
          :disabled="List.length === 0"
          @cancel="cancel"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import locationService from "@/modules/Location/service.js";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  props: ["notification", "LocationId"],
  data() {
    return {
      dialog: false,
      enableNotification: {},
      nameAndEmail: {
        name: null,
        email: null,
      },
      List: [],
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.nameAndEmail.name.$dirty) return errors;
      if (!this.$v.nameAndEmail.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.nameAndEmail.email.$dirty) return errors;
      if (!this.$v.nameAndEmail.email.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.nameAndEmail.email.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
  },
  methods: {
    async disableNotification() {
      this.$swal
        .fire({
          title: this.$t("messages.title.areYouSure"),
          text: this.$t("messages.text.disableNightlySaleNotification"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result.value) {
            await locationService.Settings.Notifications.remove(
              this.LocationId,
              this.notification.NotificationSetting.id
            )
              .then(() => {
                this.$emit("reload");
                this.$swal.fire(
                  this.$t("messages.title.disabled"),
                  "",
                  "success"
                );
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    },
    cancel() {
      this.reset();
      this.dialog = false;
    },
    open() {
      this.dialog = true;
      this.enableNotification.NotificationSetting = {
        NotificationId: this.notification.id,
        metadata: {},
        ...this.notification.NotificationSetting,
      };
      if (this.notification.NotificationSetting) {
        this.List = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata)
        );
      }
    },
    async deleted(index) {
      this.$swal
        .fire({
          title: this.$t("messages.title.areYouSure"),
          text: this.$t("messages.text.youWontBeAbleToRevert"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("buttons.yesDeleteIt"),
        })
        .then((result) => {
          if (result.value) {
            this.List.splice(index, 1);
            this.$swal.fire(
              this.$t("messages.title.deleted"),
              this.$t("messages.text.emailDeleted"),
              "success"
            );
          }
        });
    },
    async submit() {
      if (this.List.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: "top-end",
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("messages.text.addEmailToList"),
          });
        return false;
      }
      this.enableNotification.NotificationSetting = {
        ...this.enableNotification.NotificationSetting,
        metadata: this.List,
      };
      await locationService.Settings.Notifications.set(
        this.LocationId,
        this.enableNotification.NotificationSetting
      );
      this.$swal
        .mixin({
          toast: true,
          showConfirmButton: true,
          position: "top-end",
          timer: 3000,
        })
        .fire({
          icon: "success",
          title: this.$t("toastMessage.text.updated"),
        });
      this.cancel();
      this.$emit("reload");
    },
    reset() {
      this.nameAndEmail = { name: null, email: null };
      this.$v.$reset();
      this.$refs.emailName.focus();
    },
    async add() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
        return false;
      }
      if (this.List.some((row) => row.email === this.nameAndEmail.email)) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: "top-end",
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.emailAlreadyExist"),
          });
        return false;
      }
      if (this.List.length >= 5) {
        this.checkEmail = "can not store more than 5 emails";
      } else {
        this.List.push(this.nameAndEmail);
        this.reset();
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    nameAndEmail: {
      name: { required },
      email: { required, email },
    },
  },
};
</script>
